import React from 'react';
import { useParams } from 'react-router-dom';
import DepositAgentForm from '../../components/forms/DepositAgentForm/DepositAgentForm';
import AuthLayout from '../../layouts/AuthLayout/AuthLayout';

const DepositAgent = () => {

  const { uid } = useParams();

  return (
    <AuthLayout pageName="deposit-agent">
      <DepositAgentForm userId={uid} />
    </AuthLayout>
  );
};

export default DepositAgent;
